/**
 * 案子类
 */
export namespace SettleLawsuitKind {

     /** 通用数值 */  
     export enum GeneralValue {
        /** 每天使用次数 */
        MAX_USE_COUNT = 3,
        /** 默认的武器 */
        DEFAULT_WEAPON = '1',
    }

    /** 初级断案 */
    export enum PrimaryStepType {
        /** 结束步骤 */
        END = 'end',
        /** 自己说话 */
        ME = 'me',
        /** 没有动画 */
        NONE = 'none',
    }

    /** 五官类型 */
    export enum FeaturesType {
        /** 眼睛 */
        EYE = '1',
        /** 眉毛 */
        EYEBROW = '2',
        /** 鼻子 */
        NOSE = '3',
        /** 嘴唇 */
        LIP = '4',
        /** 特征 */
        FEATURE = '5',
    }

    /** 性别类型 */
    export enum SexType {
        /** 男 */
        MEN = 'men',
        /** 女 */
        WOMEN = 'women',
    }

    /** 结果类型 */
    export enum ResultType {
        /** 成功 */
        SUCCESS = 'success',
        /** 成功 */
        LOSE = 'lose',
    }
}